export default "https://cdn-static.gokick.com/assets/ba7f9a5518cadaf73eb1329111c0735c5df64124/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";